export const selectChatsState = (state) => state.chats;
export const selectNewMessageCount = (state) => state.chats?.newMessageCount;
export const selectSelectedCaseForm = (state) => state.chats?.selectedCaseForm;
export const selectSelectedReactions = (state) => state.chats?.reactions;
export const selectSelectedChat = (state) => {
  const { chatsByTenants, selectedChatId } = state.chats;
  return chatsByTenants?.[state.user.selectedTenantId]?.[selectedChatId];
};
